<template>
  <v-card elevation="0">
    <v-menu
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="selectedDate"
      min-width="100px"
      offset-y
      ref="dateVisible"
      transition="scale-transition"
      v-model="dateVisible"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :bind="attrs"
          :clear-icon="clearIcon"
          :data-cy="`packForm__${attributeName}`"
          :dense="dense"
          :hint="hint"
          :label="createLabel()"
          :rules="rules"
          @keyup.enter="$refs.dateVisible.save(selectedDate)"
          clearable
          outlined
          v-model="selectedDate"
          v-on="on"
        ></v-text-field
      ></template>
      <v-date-picker
        @input="
          dateVisible = false;
          $refs.dateVisible.save(selectedDate);
        "
        :min="minDate"
        no-title
        reactive
        scrollable
        v-model="selectedDate"
      >
      </v-date-picker>
    </v-menu>
  </v-card>
</template>

<script>
export default {
  name: "datePicker",
  computed: {
    rules() {
      return this.setRules();
    },
  },
  mounted() {
    if (this.value) {
      this.selectedDate = this.value;
    }
  },
  data() {
    return {
      dateVisible: false,
      lastSelectedDate: undefined,
      selectedDate: undefined,
    };
  },
  methods: {
    cancel() {
      this.dateVisible = false;
    },
    createLabel() {
      if (!this.isRequired) {
        return this.label;
      }
      return `${this.label} *`;
    },
    setRules() {
      const requiredMessage = `${this.label} is required`;
      const minDateMessage = `Start Date has been changed to be after End Date. Select new End Date.`;

      const message = this.minDate > this.lastSelectedDate ? minDateMessage : requiredMessage;

      if (this.isRequired) {
        return [v => !!v || message];
      }
      return [() => true];
    },
  },
  props: {
    attributeName: {
      type: String,
      default: "This field",
    },
    clearIcon: {
      type: String,
      default: "fa fa-times-circle",
    },
    dense: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Date Field",
    },
    minDate: {
      type: String,
      default: "2000-01-01",
    },
    value: {},
  },
  watch: {
    isRequired() {
      this.setRules();
      this.createLabel();
    },
    selectedDate(val) {
      this.$emit("selectedDate", val);
    },
    value(val) {
      this.selectedDate = val;
    },
    minDate() {
      if (this.minDate > this.selectedDate) {
        this.lastSelectedDate = this.selectedDate;
        this.selectedDate = null;
      }
    },
  },
};
</script>
